export const DROPDOWN_CONFIG = {
    width: 320,
    buttonWidth: 125,
};

export const CREATE_TOPICS_ITEM_ID = "create-topics";
export const CREATE_TOPIC_FROM_KW_ITEM_ID = "import-keywords";
export const TOPIC_HEADER_ID = "topicsHeader";
